import React, { useEffect, useState } from "react";
import axios from "axios";
import { all_routes } from '../../router/all_routes';
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import { Link } from 'react-router-dom';
import Sidebar from '../../../core/common/sidebar/sidebar';
import CustomSelect from '../../../core/common/commonSelect';
import { useNavigate } from "react-router-dom";
import Select from "react-select";


const ProfileSettings = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [selectedPhoto, setSelectedPhoto] = useState<File | null>(null);
  const [selectedPhotoPreview, setSelectedPhotoPreview] = useState<string | null>(null);


  const [userData, setUserData] = useState({
    nome: '',
    nacionalidade: '',
    email: '',
    telefone: '',
    endereco: '',
    pais: '',
    estado: '',
    cidade: '',
    cep: '',
    idiomas: [] as string[],
    bi: '',
    antecedentesCriminais: '',
    foto: {
      url: '',
      nome: '',
      tipo: '',
    } as any,

  });


  const [countries, setCountries] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [hasCriminalRecord, setHasCriminalRecord] = useState(false);
  const geoNamesUser = 'jvsgeoapi';
  const BASE_URL = process.env.REACT_APP_API_URL;

  // 1. Carrega os países assim que o componente monta
  useEffect(() => {
    fetchCountries();
  }, []);

  // 2. Carrega os dados do usuário após o componente montar
  useEffect(() => {
    const token = localStorage.getItem("token");
    axios.get(`${BASE_URL}/usuarios/me`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {

      setUserData({
        ...res.data,
        foto: res.data.foto || { url: '', nome: '', tipo: '' }
      });

      setHasCriminalRecord(!!res.data.antecedentesCriminais); // ✅ marca checkbox automaticamente se já existir
    }).catch(err => {
      console.error("Erro ao carregar dados do usuário", err);
    });
  }, []);


  // 3. Quando os países estiverem carregados e o país do usuário estiver setado, busca os estados
  useEffect(() => {
    if (countries.length > 0 && userData.pais) {
      const selectedCountry = countries.find(c => c.label === userData.pais);
      if (selectedCountry && selectedCountry.geonameId) {
        fetchStates(selectedCountry.geonameId);
      }
    }
  }, [countries, userData.pais]);

  // 4. Quando os estados forem carregados, e o país + estado estiverem definidos, busca as cidades
  useEffect(() => {
    if (
      states.length > 0 &&
      countries.length > 0 &&
      userData.pais &&
      userData.estado
    ) {
      const selectedCountry = countries.find(c => c.label === userData.pais);
      const selectedState = states.find(s => s.label === userData.estado);
      if (selectedCountry && selectedState) {
        fetchCities(selectedCountry.value, selectedState.value);
      }
    }
  }, [states, countries, userData.pais, userData.estado]);

  const handleChange = (
    field: keyof typeof userData,
    value: string | string[]
  ) => {
    setUserData(prev => ({ ...prev, [field]: value }));
  };

  const handlePhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedPhoto(file);

      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target?.result) {
          setSelectedPhotoPreview(event.target.result as string);
        }
      };
      reader.readAsDataURL(file);
    }
  };


  const fetchCountries = async () => {
    const res = await axios.get(`http://api.geonames.org/countryInfoJSON?username=${geoNamesUser}`);
    setCountries(res.data.geonames.map((country: any) => ({
      label: country.countryName,
      value: String(country.countryCode),
      geonameId: country.geonameId
    })));
  };

  const fetchStates = async (geonameId: number) => {
    const res = await axios.get(`http://api.geonames.org/childrenJSON?geonameId=${geonameId}&username=${geoNamesUser}`);
    const data = res.data.geonames || [];
    setStates(data.map((region: any) => ({
      label: region.name,
      value: String(region.adminCode1 || region.name)
    })));
  };

  const fetchCities = async (countryCode: string, adminCode1: string) => {
    const res = await axios.get(`http://api.geonames.org/searchJSON?country=${countryCode}&adminCode1=${adminCode1}&featureClass=P&maxRows=1000&username=${geoNamesUser}`);
    const data = res.data.geonames || [];
    setCities(data.map((city: any) => ({
      label: city.name,
      value: String(city.name)
    })));
  };

  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      // Atualiza os dados principais primeiro
      await axios.put(`${BASE_URL}/usuarios/me`, userData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Se houver foto nova, faz upload
      if (selectedPhoto) {
        const formData = new FormData();
        formData.append("file", selectedPhoto);

        const response = await axios.put(`${BASE_URL}/usuarios/me/foto`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });

        // Atualiza a foto no estado com o novo ID retornado
        const fotoUrl = response.data.fotoUrl; // ex: "/api/uploads/123"
        const novaFotoId = fotoUrl.split("/").pop();

        setUserData((prev) => ({
          ...prev,
          foto: {
            id: novaFotoId,
            url: fotoUrl,
          },
        }));

        setSelectedPhoto(null);
        setSelectedPhotoPreview(null);
      }

      alert("Perfil atualizado com sucesso!");
      navigate("/user/my-profile");
    } catch (err) {
      console.error("Erro ao salvar dados", err);
      alert("Erro ao salvar alterações.");
    }
  };

  const breadcrumbs = [
    { label: 'Settings', link: routes.home1, active: false },
    { label: 'Profile Settings', active: true }
  ];

  return (
    <div>
      <Breadcrumb
        title="Settings"
        breadcrumbs={breadcrumbs}
        backgroundClass="breadcrumb-bg-04"
      />
      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-lg-4">
              <Sidebar />
            </div>
            <div className="col-xl-9 col-lg-8">
              <div className="card settings mb-0">
                <div className="card-header">
                  <h6>Settings</h6>
                </div>
                <div className="card-body pb-3">
                  <div className="settings-link d-flex align-items-center flex-wrap">
                    <Link to={routes.profileSettings} className="active ps-3">
                      <i className="isax isax-user-octagon me-2" /> Profile Settings
                    </Link>
                    <Link to={routes.securitySettings}><i className="isax isax-shield-tick me-2" /> Security</Link>
                    <Link to={routes.notificationSettings}><i className="isax isax-notification me-2" /> Notifications</Link>
                    <Link
                      to={routes.userPreferences}
                      className="ps-3 pe-3"
                    >
                      <i className="isax isax-setting-2 me-2" />
                      Preferences
                    </Link>
                    <Link to={routes.integrationSettings} className="pe-3">
                      <i className="isax isax-hierarchy me-2" /> Integrations
                    </Link>
                  </div>

                  <div className="settings-content mb-4">
                    <h6 className="fs-16 mb-3">Foto de Perfil</h6>
                    <div className="d-flex align-items-center gap-3">
                      {selectedPhotoPreview ? (
                        <img
                          src={selectedPhotoPreview}
                          alt="Foto Preview"
                          className="img-fluid"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      ) : userData?.foto?.id ? (
                        <img
                          src={`${BASE_URL}/uploads/${userData.foto.id}?v=${new Date().getTime()}`}
                          alt="Foto de Perfil"
                          className="img-fluid"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      ) : (
                        <div style={{/* seu style padrão para inicial */ }}>
                          {userData?.nome
                            ? userData.nome
                              .split(" ")
                              .map((n) => n[0])
                              .join("")
                              .toUpperCase()
                            : "U"}
                        </div>
                      )}

                      <label className="btn btn-outline-primary btn-sm mb-0" style={{ cursor: "pointer" }}>
                        Alterar Foto
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handlePhotoChange}
                          style={{ display: "none" }}
                        />
                      </label>
                    </div>
                  </div>

                  <div className="settings-content mb-3">
                    <h6 className="fs-16 mb-3">Basic Information</h6>
                    <div className="row gy-2">
                      <div className="col-lg-6">
                        <label className="form-label">Full Name</label>
                        <input type="text" className="form-control" value={userData.nome} onChange={(e) => handleChange("nome", e.target.value)} />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Nationality</label>
                        <input type="text" className="form-control" value={userData.nacionalidade} onChange={(e) => handleChange("nacionalidade", e.target.value)} />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Email</label>
                        <input type="email" className="form-control" value={userData.email} onChange={(e) => handleChange("email", e.target.value)} />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">BI (Bilhete de Identidade)</label>
                        <input
                          type="text"
                          className="form-control"
                          value={userData.bi}
                          onChange={(e) => handleChange("bi", e.target.value)}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Phone</label>
                        <input type="text" className="form-control" value={userData.telefone} onChange={(e) => handleChange("telefone", e.target.value)} />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <label className="form-label">Languages Spoken</label>
                      <Select
                        isMulti
                        options={[
                          { label: 'English', value: 'English' },
                          { label: 'Portuguese', value: 'Portuguese' },
                          { label: 'Spanish', value: 'Spanish' },
                          { label: 'French', value: 'French' },
                          { label: 'German', value: 'German' },
                        ]}
                        value={(userData.idiomas || []).map(idioma => ({ label: idioma, value: idioma }))}
                        onChange={(selected) =>
                          handleChange(
                            'idiomas',
                            Array.isArray(selected) ? selected.map(item => item.value) : []
                          )
                        }
                      />
                    </div>
                    <div className="row gy-2 mt-3">
                      <div className="col-lg-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="antecedentesCheck"
                            checked={hasCriminalRecord}
                            onChange={(e) => {
                              setHasCriminalRecord(e.target.checked);
                              if (!e.target.checked) {
                                handleChange("antecedentesCriminais", ""); // limpa o campo ao desmarcar
                              }
                            }}
                          />
                          <label className="form-check-label" htmlFor="antecedentesCheck">
                            Possui antecedentes criminais?
                          </label>
                        </div>
                      </div>

                      {hasCriminalRecord && (
                        <div className="col-lg-6">
                          <label className="form-label">Antecedentes Criminais</label>
                          <input
                            type="text"
                            className="form-control"
                            value={userData.antecedentesCriminais}
                            onChange={(e) => handleChange("antecedentesCriminais", e.target.value)}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="settings-content">
                    <h6 className="fs-16 mb-3">Address Information</h6>
                    <div className="row gy-2">
                      <div className="col-lg-12">
                        <label className="form-label">Address</label>
                        <input type="text" className="form-control" value={userData.endereco} onChange={(e) => handleChange("endereco", e.target.value)} />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Country</label>
                        <CustomSelect
                          options={countries}
                          placeholder="Select"
                          value={countries.find(opt => opt.label === userData.pais)}
                          onChange={(e) => {
                            handleChange("pais", e?.label || "");
                            handleChange("estado", "");
                            handleChange("cidade", "");
                          }}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">State</label>
                        <CustomSelect
                          options={states}
                          placeholder="Select"
                          value={states.find(opt => opt.label === userData.estado)}
                          onChange={(e) => {
                            handleChange("estado", e?.label || "");
                            handleChange("cidade", "");
                          }}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">City</label>
                        <CustomSelect
                          options={cities}
                          placeholder="Select"
                          value={cities.find(opt => opt.label === userData.cidade)}
                          onChange={(e) => handleChange("cidade", e?.label || "")}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Postal Code</label>
                        <input type="text" className="form-control" value={userData.cep} onChange={(e) => handleChange("cep", e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="d-flex align-items-center justify-content-end">
                    <Link to="/user/my-profile" className="btn btn-light me-2">Cancel</Link>
                    <button className="btn btn-primary" onClick={handleSave}>Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSettings;
